import { createContext, useContext } from 'react';
import { InAppNotificationsContextValue } from 'src/context/InAppNotificationsProvider/InAppNotificationsProvider.types';

export const InAppNotificationsContext = createContext<
  InAppNotificationsContextValue | undefined
>(undefined);

export default function useInAppNotificationsContext() {
  const context = useContext(InAppNotificationsContext);
  if (!context) {
    throw new Error(
      'useInAppNotificationsContext must be used within a InAppNotificationsProvider'
    );
  }
  return context;
}
